import { FC } from 'react';

import { Box, Grid } from '@mui/material';

import { FormSectionFilledCard } from 'components/_basic/FormSectionFilledCard';

import { InvestmentGridColumns } from '../InvestmentGridColumns';
import { InvestmentGridHeader } from '../InvestmentGridHeader';

import styles from './InvestmentGridComponent.module.scss';

export interface IInvestmentGridComponent {
  name: string;
  disabled: boolean;
}

export const InvestmentGridComponent: FC<IInvestmentGridComponent> = ({ name }) => {
  return (
    <Grid container gap={1.5}>
      <FormSectionFilledCard className={styles.contentWrapper}>
        <Box className={styles.content}>
          <InvestmentGridHeader disabled />
          <InvestmentGridColumns name={name} />
        </Box>
      </FormSectionFilledCard>
    </Grid>
  );
};
